import { normalizeProductId } from '../../../product'

export const algoliaQueryAccessorGetObjectIdFiltersQuery = (
  pzns: string[] | string,
): string => {
  let objectIdFiltersQuery = ''
  if (typeof pzns !== 'string') {
    objectIdFiltersQuery = pzns
      .map((pzn) => `objectID:${normalizeProductId(pzn)}`)
      .join(' OR ')
  }

  return objectIdFiltersQuery
}
